import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-show-targets',
  templateUrl: './show-targets.component.html',
  styleUrls: ['./show-targets.component.scss']
})
export class ShowTargetsComponent implements OnInit {
  apisub:Subscription
  targetsData:any = []
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata:any,
    private ls:LoaderServiceService,
    private apiservice: ApiService,

  ) { 

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_WHATSAPP_CAMPAIGN_TARGETS){
        this.targetsData = []
        if(resdata.result){
          this.targetsData = resdata.result
        }
        this.ls.showLoader = false
        this.isloader = false
      }

    })

  }
isloader: boolean = false
  ngOnInit(): void {
    // console.log(this.parentdata);
    this.isloader = true
    this.apiservice.getEntityWhatsAppCampaignTargets(this.parentdata.campaignData.hash_id)
  }

}
